import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

import { useTranslation } from '@gem/modules/i18n';

import Entities from 'STORE';
import { Group } from 'STORE/Groups/Group';

interface IGroupStatusPresenter {
  group: Group;
  status: string | null;
  setGroup(group: Group): void;
}

export const useGroupStatusPresenter = (group: Group): IGroupStatusPresenter => {
  const { t } = useTranslation();

  const presenter = useLocalObservable(() => ({
    group,

    get status(): string | null {
      const events = presenter.group.userTyping.events;

      if (events.length === 0) {
        return null;
      }

      if (presenter.group.isP2P) {
        return t('p2p_typing_placeholder');
      }
      if (events.length > 2) {
        return t('several_users_typing_placeholder');
      }

      const userNames = events.map((event) => {
        const user = Entities.usersStore.getUserById(event.userId);
        return user ? user.displayName : event.userName;
      });

      const placeholder: Record<number, string> = {
        1: t('is_typing_placeholder', { 0: userNames[0] }),
        2: t('two_users_typing_placeholder', { 0: userNames[0], 1: userNames[1] }),
      };

      return placeholder[userNames.length] || null;
    },

    setGroup(group: Group): void {
      presenter.group = group;
    },
  }));

  useEffect(() => {
    presenter.setGroup(group);
  }, [group]);

  return presenter;
};
